<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">For five hundred years, people have been writing about Florida and in Florida. This book features a broad selection of the authors, but for every author who is included there are five who are not. As always, I appreciate the work of the Florida Archives and Katelyn Herring and Adam Watson. Laureen Crowley once again tackled the daunting task of editing with good humor and great skill. Finally, my editor at The History Press, Joe Gartrell, has once again come through with his combination of sage advice, great patience and gentle nudging. Thanks to all.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?4452f75a